import React, { useState } from "react";
import { Button, Modal, Form, message, Tabs } from "antd";
import { Header } from "../../../../components";
import { UseFetchCaseSetting, UseCreateCaseSetting, UseUpdateCaseSetting , UseDeleteCaseSetting, UseToggleCaseEnable} from "../hooks/useFetch";
import Table from "../components/Table";
import CaseForm from "../components/CaseForm";
import CaseFormTable from "../components/CaseFormTable";
import { REGISTER_TASK } from "../../../../data/constant";

function CasePage() {
  const companyId = sessionStorage.getItem('activeCompanyId')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [caseId, setCaseId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const { data: cases = [], isLoading, refetch: refetchCase } = UseFetchCaseSetting(companyId);
  const { mutate: createCase } = UseCreateCaseSetting();
  const { mutate: updateCase } = UseUpdateCaseSetting();
  const { mutate: deleteCase } = UseDeleteCaseSetting();
  const { mutateAsync: toggleEnable } = UseToggleCaseEnable();
  const [togglingId, setTogglingId] = useState(null);
  const depositCases = cases.filter((caseItem) => caseItem.type == "1");
  const withdrawCases = cases.filter((caseItem) => caseItem.type == "2");
  const etcCases = cases.filter((caseItem) => caseItem.type == "3");
  const panelCases = cases.filter((caseItem) => caseItem.type == "4");
  const registerCases = cases.filter((caseItem) => String(caseItem.type) === "5");

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        type: activeTab,
        companyId: companyId
      };

      if (isEditing) {
        // Update existing case
        await updateCase({ ...payload, id: caseId });
        message.success("Case updated successfully");
      } else {
        // Create new case
        await createCase(payload);
        message.success("Case created successfully");
      }

      // Only close modal and reset form if validation and API call succeed
      setTimeout(() => {
        refetchCase();
      }, 1000);
      setIsModalOpen(false);
      form.resetFields();
      setIsEditing(false);
      setCaseId(null);
    } catch (error) {
      // If validation fails or API call fails, don't close the modal
      // The form will show validation errors automatically
      console.log("Validation or API error:", error);
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setIsEditing(false);
    setCaseId(null);
  };

  const handleDelete = (record) => {
    console.log(record.id);
    deleteCase(record.id);
    setTimeout(() => {
      refetchCase();
    }, 1000);
  };

  const handleEdit = (record) => {
    setCaseId(record.id);
    setIsEditModalOpen(true);
  };

  // เปิด/ปิด case2 (CaseTopic) — ปิด = ไม่โชว์ในหน้าทำงาน แต่หน้ารายงานยังเห็น
  const handleToggleEnable = async (record, checked) => {
    setTogglingId(record.id);
    try {
      await toggleEnable({ id: record.id, target: "case2", enable: checked });
      message.success(checked ? "เปิดแสดงแล้ว" : "ปิดแล้ว (ซ่อนจากหน้าทำงาน)");
      refetchCase();
    } catch (e) {
      message.error("เปลี่ยนสถานะไม่สำเร็จ");
    } finally {
      setTogglingId(null);
    }
  };


  const handleEditModalCancel = () => {
    setIsEditModalOpen(false);
    form.resetFields();
  };

  const handleEditCase = (record) => {
    setIsEditing(true);
    setCaseId(record.id);
    form.setFieldsValue({
      case_name: record.casename,
      number: record.number,
      remark: record.remark,
    });
    setIsModalOpen(true);
  };

  const items = [
    {
      key: "1",
      label: "Deposit",
      children: (
        <Table
          data={depositCases}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onEditCase={handleEditCase}
          onToggleEnable={handleToggleEnable}
          togglingId={togglingId}
          loading={isLoading}
          bordered
        />
      ),
    },
    {
      key: "2",
      label: "Withdraw",
      children: (
        <Table
          data={withdrawCases}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onEditCase={handleEditCase}
          onToggleEnable={handleToggleEnable}
          togglingId={togglingId}
          loading={isLoading}
          bordered
        />
      ),
    },
    {
      key: "3",
      label: "ETC.",
      children: (
        <Table
          data={etcCases}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onEditCase={handleEditCase}
          onToggleEnable={handleToggleEnable}
          togglingId={togglingId}
          loading={isLoading}
          bordered
        />
      ),
    },
    {
      key: "4",
      label: "Panel",
      children: (
        <Table data={panelCases} onEdit={handleEdit} onDelete={handleDelete} onEditCase={handleEditCase} onToggleEnable={handleToggleEnable} togglingId={togglingId} loading={isLoading} bordered />
      ),
    },
    {
      key: "5",
      label: REGISTER_TASK,
      children: (
        <Table
          data={registerCases}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onEditCase={handleEditCase}
          onToggleEnable={handleToggleEnable}
          togglingId={togglingId}
          loading={isLoading}
          bordered
          visible={false}
        />
      ),
    },
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="md:m-10">
      <div className="flex justify-between mb-6">
        <Header category="App" title="Cases" />
        <Button
          className="mt-4"
          type="primary"
          onClick={() => setIsModalOpen(true)}
        >
          Add Case
        </Button>
      </div>

      <Tabs 
        defaultActiveKey="1" 
        items={items} 
        onChange={handleTabChange}
        activeKey={activeTab}
      />

      <Modal
        title={`Add New ${items.find(item => item.key === activeTab)?.label} Case`}
        open={isModalOpen}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
      >
        <CaseForm 
          form={form} 
          activeTab={items.find(item => item.key === activeTab)?.label} 
        />
      </Modal>

      <Modal
        title={`Edit ${items.find(item => item.key === activeTab)?.label} Case`}
        open={isEditModalOpen}
        onCancel={handleEditModalCancel}
        width="70%"
        centered
        footer={null}
        style={{
          maxWidth: '1200px',
          overflow: 'auto',
        }}
        bodyStyle={{
          maxHeight: '80vh',
          overflow: 'auto',
          padding: '16px'
        }}
      >
        <CaseFormTable
          form={form}
          caseId={caseId}
          cases={cases}
          refetch={refetchCase}
        />
      </Modal>
    </div>
  );
}

export default CasePage;
